module.exports = __webpack_public_path__ + "img/UTREDF-6.b65a0ab9.jpg";